import AppWrap from './AppWrap';

export default AppWrap;
